import styled from '@emotion/styled';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ToggleSwitch = styled.div<{ checked: boolean; disabled?: boolean }>`
  position: relative;
  width: 44px;
  height: 24px;
  background-color: ${({ checked }) => (checked ? 'var(--prim4)' : '#ccc')};
  border-radius: 12px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.3s ease;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:hover {
    background-color: ${({ checked, disabled }) =>
      disabled ? (checked ? 'var(--prim4)' : '#ccc') : checked ? 'var(--prim3)' : '#999'};
  }
`;

const ToggleSlider = styled.div<{ checked: boolean }>`
  position: absolute;
  top: 2px;
  left: ${({ checked }) => (checked ? '22px' : '2px')};
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const ToggleLabel = styled.span`
  font-size: 14px;
  color: var(--text-primary);
  user-select: none;
`;

const Toggle = ({ checked, onChange, label, disabled = false }: ToggleProps) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <ToggleWrapper>
      <ToggleSwitch checked={checked} disabled={disabled} onClick={handleToggle}>
        <ToggleSlider checked={checked} />
      </ToggleSwitch>
      {label && <ToggleLabel onClick={handleToggle}>{label}</ToggleLabel>}
    </ToggleWrapper>
  );
};

export default Toggle;
